export const organizationTypes = [
  { label: "Company", value: "company" },
  { label: "NGOs", value: "ngos" },
  { label: "Government Agencies", value: "government agencies" },
  { label: "Airline", value: "airline" },
  { label: "MRO", value: "mro" },
  { label: "Training Institute", value: "training institute" },
  { label: "Airfield Operators", value: "airfield operators" },
  { label: "Advocacy Groups", value: "advocacy groups" },
  { label: "Other", value: "other" },
];

export const jobTypes = [
  { label: "Full-time", value: "full-time" },
  { label: "Part-time", value: "part-time" },
  { label: "Contract", value: "contract" },
  { label: "Temporary", value: "temporary" },
];

export const aircraftTypeChoices = [
  { label: "A320", value: "A320" },
  { label: "B737", value: "B737" },
  { label: "ATR72", value: "ATR72" },
  { label: "H135", value: "H135" },
];

export const visaRequirementsChoices = [
  { label: "Local Only", value: "local" },
  { label: "Will Sponsor", value: "sponsor" },
  { label: "Remote", value: "remote" },
];

export const medicalClassChoices = [
  { label: "Class 1", value: "class_1" },
  { label: "Class 2", value: "class_2" },
  { label: "LAPL", value: "lapl" },
];

export const qualificationChoices = [
  { label: "Diploma", value: "diploma" },
  { label: "BSc", value: "bsc" },
  { label: "CPL", value: "cpl" },
  { label: "ATPL", value: "atpl" },
  { label: "EASA Part-66 B1", value: "easa_part_66_b1" },
];

export const experienceLevelChoices = [
  { label: "0-2 years: Entry Level", value: "entry" },
  { label: "3-5 years: Mid Level", value: "mid" },
  { label: "6-10 years: Senior Level", value: "senior" },
  { label: "10+ years: Executive Level", value: "executive" },
];

export const visilityChoices = [
  { label: "Public - Visible to everyone", value: "public" },
  { label: "Verified Professionals Only", value: "verified" },
  { label: "Private - By invitation only", value: "private" },
  { label: "Internal - Visible only to admins", value: "internal" },
];

export const statusChoices = [
  { label: "Draft", value: "draft" },
  { label: "Active", value: "active" },
  // { label: "Closed", value: "closed" },
  // { label: "Expired", value: "expired" },
];

export const aviationDepartments = [
  { label: "Flight Operations", value: "flight_operations" },
  { label: "Cabin Crew / In-Flight Services", value: "cabin_crew" },
  { label: "Ground Operations", value: "ground_operations" },
  {
    label: "Maintenance & Engineering (MRO)",
    value: "maintenance_engineering",
  },
  { label: "Safety & Security", value: "safety_security" },
  { label: "Air Traffic Control", value: "air_traffic_control" },
  { label: "Training & Simulator Operations", value: "training" },
  { label: "Commercial / Sales / Marketing", value: "commercial" },
  {
    label: "Customer Service / Passenger Experience",
    value: "customer_service",
  },
  { label: "Cargo & Logistics", value: "cargo_logistics" },
  { label: "Regulatory & Compliance", value: "regulatory_compliance" },
  { label: "Administration & Human Resources", value: "administration_hr" },
  { label: "Finance & Accounting", value: "finance" },
  { label: "IT & Digital Systems", value: "it_digital" },
  { label: "Corporate / Executive Management", value: "corporate_management" },
];
